import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { StoryblokComponent, storyblokEditable } from "@storyblok/react"
import { AsideIllustration } from "@/components/molecules/AsideIllustration"
import { type SbBlokAsideIllustration } from "../types"
import { StoryblokImage } from "./StoryblokImage"

interface DynamicAsideIllustrationProps {
    blok: SbBlokAsideIllustration
}

export default function DynamicAsideIllustration({ blok }: DynamicAsideIllustrationProps) {
    if (!blok?.blocks?.length) {
        return (
            <StoryblokMissingField
                blok="AsideIllustration"
                field="Blocks"
            />
        )
    }

    if (!blok.src?.filename || !blok.src.alt) {
        return (
            <StoryblokMissingField
                blok="AsideIllustration"
                field="Src"
            />
        )
    }

    return (
        <div {...storyblokEditable(blok)}>
            <AsideIllustration
                image={
                    <StoryblokImage
                        src={blok.src.filename}
                        alt={blok.src.alt}
                    />
                }
                reverse={blok.reverse}
                shiftImage={blok.shiftImage}
            >
                {blok.blocks.map((nestedBlok) => (
                    <StoryblokComponent
                        blok={nestedBlok}
                        key={nestedBlok._uid}
                    />
                ))}
            </AsideIllustration>
        </div>
    )
}
